module.exports = __webpack_public_path__ + "static/media/white-add.32d90b09.svg";